import request from '../../util/SuperagentUtils';

export const getInvoicesInPayout = (payoutCorrelationId) => {
  return request.get(`/api/invoices/${payoutCorrelationId}/transactions`);
}
